<template>
  <div class="account-table-container default-table">
    <ApeTable ref="apeTable"
              :data="dataList"
              :columns="columns"
              :loading="loadingStatus"
              :pagingData="pagingData"
              :is-full-height="true"
              @switchPaging="switchPaging"
              @selectList="handleSelectionChange"
              highlight-current-row
              border>
      <el-table-column slot="first-column" type="selection" min-width="55"></el-table-column>
      <el-table-column
              slot="first-column"
              min-width="60"
              label="序号">
        <template slot-scope="scope">
          <span>{{ offset + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
              slot="second-column"
              prop="customer_name"
              label="客户名称"
              header-align="center"
              align="left"
              min-width="250"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.customer_name }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="order_no"
              label="订单编号"
              header-align="center"
              align="center"
              min-width="160"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.order_no }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="sale"
              label="销售"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.sale }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="amount"
              label="回款金额"
              header-align="center"
              align="right"
              min-width="120"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ moneyFormat(scope.row.amount) }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="pay_term"
              label="收款方式"
              header-align="center"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.pay_term }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="transfer_time"
              label="回款时间"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.transfer_time }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="claim_time"
              label="认领时间"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.claim_time }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="check_time"
              label="确认时间"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.check_time }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="remark"
              label="备注"
              header-align="center"
              align="left"
              min-width="240"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="created_at"
              label="创建时间"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
      >
        <!--          <template slot-scope="scope">-->
        <!--            <span>{{ gFunc.parseTime(scope.row.created_at, '{y}-{m}-{d} {h}:{i}:{s}') }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <el-table-column
              prop="updated_at"
              label="修改时间"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
      >
        <!--          <template slot-scope="scope">-->
        <!--            <span>{{ gFunc.parseTime(scope.row.updated_at, '{y}-{m}-{d} {h}:{i}:{s}') }}</span>-->
        <!--          </template>-->
      </el-table-column>
    </ApeTable>
  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable";
import {getAccountPageList} from "@/api/account";
import {gFunc} from "@/globalFunc";

export default {
  name: "AccountTable",
  components: {
    ApeTable,
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  created() {
    // this.getTableThead()
  },
  mounted() {
    // this.initList()
  },
  data() {
    return {
      // 表格列表数据
      dataList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 20,
        // offset: 0
      },
      // 分页的offset,序号列使用
      offset: 0,
      columns: [],
      columnsFixed: ['customer_name'],//固定字段
      columnsExclude: ['customer_name'],//循环排除，特定样式
      loadingStatus: false,

    }
  },
  props: {
    searchCondition: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    searchCondition: {
      deep: true,
      // eslint-disable-next-line
      handler(val) {
        // eslint-disable-next-line
        // console.log('val', val)
        this.initList()
      }
    }
  },
  methods: {
    init(searchCondition) {
      this.searchCondition = searchCondition
      this.$refs['apeTable'].handleCurrentChange(1)
    },
    // 切换页码操作
    async switchPaging() {
      await this.initList()
    },
    // 勾选事件
    handleSelectionChange(val) {
      this.selectList = val
      this.$emit('handleSelectionChange', val)
    },
    async initList(type) {
      this.dataList = []
      this.loadingStatus = true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      let searchCondition = this.searchCondition;
      Object.assign(searchCondition, pagingInfo)
      let {list, pages} = await getAccountPageList(searchCondition).then(res => {
        return res.data
      });

      this.$nextTick(() => {
        this.dataList = list
      })

      this.pagingData.total = pages.total
      this.offset = pages.offset

      this.loadingStatus = false

    },

    goDetail(row) {
      this.$emit('goDetail', row)
    },
    moneyFormat(val) {
      return gFunc.numberFormat(val, 2)
    }
  }
}
</script>

<style lang="scss">
.account-table-container {
  height: calc(100% - 100px);
}
</style>
